import React, { useState, useEffect } from "react";
import Searchbar from "./coinSearchbar";
import Searchresultlist from "./searchresultlist";
import CoinSearchbar from "./coinSearchbar";
import { AXIOS, api_key } from "../../../config";
import { toast } from "react-toastify";

export default function CoinSearchbox({ setSelectedOption, closeModal, setSearchResults, data, searchResults }) {

  return (
    <>
      <CoinSearchbar setSearchResults={setSearchResults} data={data} />
      <Searchresultlist searchResults={searchResults} setSelectedOption={setSelectedOption} closeModal={closeModal} setSearchResults={setSearchResults} data={data} />
    </>
  );
}
